import { config } from "../utils/config";
import { omniAxios } from "../utils/axios";
//弹窗埋点
export function buryPointInsertRecordPoint(data) {
  return omniAxios({
    url: config.buryPointInsertRecordPath,
    isApiPath: true,
    useDevServerProxy: true,
    withCredentials: false,
    method: "post",
    params: data,
  });
}
